// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"b2a8e7bd","990":"0b1b2d9d"}[chunkId] + ".chunk.js";
};